export const U_STORE = "$uStore"